import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Card } from '../../../components/Card';
import { HBox, VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { IsOpen } from '../../../components/Icon';
import { ChangeLocationModal } from './ChangeLocationModal';
import { setVehicleLocation } from '../actions';
import { CompanyLabel } from '../../Companies/components/CompanyLabel';
import { fetchCompany } from '../../Companies/actions';
import { fetchAddress } from '../../Address/actions';
import { FormField } from '../../../components/FormFields';
import { Input } from '../../../components/Input';
import { makeSelectLocale } from '../../../containers/LanguageProvider/selectors';
import { translateCountry } from '../../Companies/translate-countries';
import ButtonComponent from '../../../containers/App/Components/Button/Button';

const Container = styled.div`
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }
`;

const Address = styled.div`
  border: 1px solid rgb(21, 172, 121);
  border-radius: 6px;
  padding: 12px;
  width: 100%;
  margin: 6px 0;
  font-size: 12px;

  .button {
    margin: 0 -12px;
  }
  .name {
    font-size: 12px;
  }
  .address {
    margin-top: 12px;
  }
`;

const STATE = {
  address: null,
  company: null,
  showLocationChange: false,
  manualAddress: {
    company_name: '',
    addressLine1: '',
    postcode: '',
    city: '',
    country: { name: '' },
  },
};

/* eslint-disable react/prefer-stateless-function */
class VehicleCMRLocationComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.defaultCompanyId &&
      this.props.fetchCompany(this.props.defaultCompanyId, result => {
        if (result?.id) {
          this.setState({
            company: result,
            address: result?.addresses[0],
          });
          this.props.setLocation({ company: result, address: result?.addresses[0], type: this.props.type });
        }
      });
    this.props.defaultAddressId &&
      this.props.fetchAddress(this.props.defaultAddressId, result => {
        if (result?.id) {
          this.setState({
            address: result,
          });
          this.props.setLocation({ address: result, type: this.props.type });
        }
      });
  }

  get locale() {
    return this.props.locale;
  }

  get showCountryId() {
    return this.props.type == 'consignee' || this.props.type == 'placeDeliveryGoods';
  }

  get isChangeableLocation() {
    return this.props.type != 'placeDeliveryGoods';
  }

  onSetLocation = (company, address) => {
    // this.props.changeLocation(this.props.vehicle?.id, company?.id, address?.id);
    this.setState({
      company,
      address,
      showLocationChange: false,
      setLocationManual: false,
    });

    this.props.setLocation({ company, address, type: this.props.type });
  };

  onManualInputChange(e) {
    e.persist();

    if (e.target.name == 'country') {
      return this.setState(prev => {
        return {
          manualAddress: {
            ...prev.manualAddress,
            country: {
              name: e.target?.value,
            },
          },
        };
      });
    }
    this.setState(prev => {
      return {
        manualAddress: { ...prev.manualAddress, [e.target?.name]: e.target?.value },
      };
    });
  }

  renderAddress = () => {
    // const company = this.props.vehicle?.locationCompany;
    const company = this.state.company;
    const address = this.state.address || this.props.address;

    if (!address || this.state.setLocationManual) return null;

    return (
      <Address key={`${address?.id}`}>
        {company ? (
          <span className="name" style={{ textTransform: 'uppercase', fontWeight: 600 }}>
            <CompanyLabel company={company} />
          </span>
        ) : null}
        {address?.company_name && (
          <span className="name" style={{ textTransform: 'uppercase', fontWeight: 600 }}>
            <span className="company-label">{address?.company_name}</span>
          </span>
        )}
        <HBox vCenter left>
          {this.props.type !== 'placeDeliveryGoods' && this.lbl(`address.type.${address?.type?.name || 'other'}`)}
          &nbsp;
          {/* {this.props.vehicle?.location_address_id && `(${this.props.vehicle?.location_address_id})`} */}
        </HBox>
        <VBox left>
          <div>{this.props.type !== 'placeDeliveryGoods' && address?.addressLine1}</div>
          <div>
            {this.props.type !== 'placeDeliveryGoods' && address?.postcode} {address?.city}
          </div>
          <div>{translateCountry(address.country?.name, this.locale)}</div>
        </VBox>
      </Address>
    );
  };

  render() {
    const { vehicle } = this.props;
    return (
      <Card className="vehicle-info-card info-card data">
        <Container>
          <HBox>
            <h2>
              {this.props.fieldNumber}&nbsp;{this.props.title}
            </h2>
          </HBox>
          {this.isChangeableLocation && (
            <HBox right>
              <ButtonComponent style={'ButtonSoftEdit'} onClick={this.setStateFn({ setLocationManual: true })}>
                {this.lbl('vehicle.location.manual')}
              </ButtonComponent>
              <ButtonComponent style={'ButtonSoftEdit'} disabled={this.state.setLocationManual} onClick={this.setStateFn({ showLocationChange: true })}>
                {this.lbl('vehicle.location.change')}
              </ButtonComponent>
            </HBox>
          )}
          {this.renderAddress()}
          {this.state.setLocationManual && (
            <VBox>
              <FormField>
                <Input
                  full
                  name="company_name"
                  placeholder={'company_name'}
                  value={this.state.manualAddress.company_name}
                  onChange={this.onManualInputChange.bind(this)}
                />
              </FormField>
              <FormField>
                <Input
                  full
                  name="addressLine1"
                  placeholder={'addressLine1'}
                  value={this.state.manualAddress.addressLine1}
                  onChange={this.onManualInputChange.bind(this)}
                />
              </FormField>
              <FormField>
                <Input
                  full
                  name="postcode"
                  placeholder={'post_code'}
                  value={this.state.manualAddress.postcode}
                  onChange={this.onManualInputChange.bind(this)}
                />
              </FormField>
              <FormField>
                <Input
                  full
                  name="city"
                  placeholder={'city'}
                  value={this.state.manualAddress.city}
                  onChange={this.onManualInputChange.bind(this)}
                />
              </FormField>
              <FormField>
                <Input
                  full
                  name="country"
                  placeholder={'country'}
                  value={this.state.manualAddress?.country?.name}
                  onChange={this.onManualInputChange.bind(this)}
                />
              </FormField>
              <HBox left>
                <Button primary small onClick={() => this.onSetLocation({}, this.state.manualAddress)}>
                  {this.lbl('save')}
                </Button>
                <Button warning small onClick={this.setStateFn({ setLocationManual: false })}>
                  {this.lbl('cancel')}
                </Button>
              </HBox>
            </VBox>
          )}
          {this.state.showLocationChange && (
            <ChangeLocationModal
              company={vehicle?.locationCompany}
              address={vehicle?.locationAddress}
              onClose={() => this.setState({ showLocationChange: false })}
              onConfirm={this.onSetLocation}
            />
          )}
        </Container>
      </Card>
    );
  }
}

VehicleCMRLocationComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchCompany(companyId, callback) {
      dispatch(fetchCompany(companyId, callback));
    },
    fetchAddress(addressId, callback) {
      dispatch(fetchAddress(addressId, callback));
    },
    changeLocation(vehicleId, companyId, addressId) {
      dispatch(setVehicleLocation(vehicleId, companyId, addressId));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleCMRLocation = compose(withConnect, withRouter)(VehicleCMRLocationComp);
